module.exports = __webpack_public_path__ + "img/2-1.b4843d04.svg";